import templateUrl from 'emun.offer/offers-list.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

class OffersListController  {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
        let options = {
            url: 'QueryOffers.json',
            pageSize: 12,
            autoLoad: true,
            append: false,
        };
        $ctrl.query = new AutoQuery(options);
        $ctrl.bus = $ctrl.query.bus;
    }
    load() { return this.query.load(); }

    deleteOffer(m) {
        let $ctrl = this;
        return modals.confirm("Are you sure?", "Delete Offer").result.then(function () {
            return $ctrl.bus.send('DeleteOffer', m)
            .then(function (response) {
                $ctrl.query.load(true);
            });
        });
    };

    activateOffer(m) {
        let $ctrl = this;
        return $ctrl.bus.send('ActivateOffer', m)
        .then(function (response) {
            $ctrl.query.load(true);
        });
    };

    deactivateOffer(m) {
        let $ctrl = this;
        return $ctrl.bus.send('DeactivateOffer', m)
        .then(function (response) {
            $ctrl.query.load(true);
        });
    };
}

let OffersList = {
    controller: OffersListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default OffersList;